export default "__VITE_ASSET__1a950a85__"